import { IkeDateFormat } from '@ikegps/core-shared';
import { type IkeClientService, Services } from './index';

export type ISOCache = { [iso: string]: Date };

// Formatting delegates to IkeDateFormat, which memoises the (expensive-to-build)
// Intl.DateTimeFormat instances internally — so no output-string cache is needed here.
// The only cache kept is ISO_CACHE, which reuses parsed Date objects.
export class DateTimeService implements IkeClientService {
	__priority = 100;

	ISO_CACHE: ISOCache = {};

	getDate(iso: string): Date {
		const searchString = iso.slice(0, -5) + '.000Z';
		return this.ISO_CACHE[searchString] || (this.ISO_CACHE[searchString] = new Date(searchString));
	}

	getTime(iso: string): number {
		return this.getDate(iso).getTime();
	}

	/** Written date in the user's format, e.g. `June 13, 2026` / `13 June 2026`. */
	formatDate(value: string | Date): string {
		const date: Date = typeof value === 'string' ? this.getDate(value) : value;
		return IkeDateFormat.long(date, Services.UserSettings.dateFormat);
	}

	/** Written date + 12-hour time in the user's format, e.g. `June 13, 2026 2:30 PM`. */
	formatDateTime(value: string | Date | undefined): string {
		if (value == null) {
			return '';
		}
		const date: Date = typeof value === 'string' ? this.getDate(value) : value;
		return IkeDateFormat.longDateTime(date, Services.UserSettings.dateFormat);
	}

	padNumber(num: number): string {
		var norm = Math.abs(Math.floor(num));
		return (norm < 10 ? '0' : '') + norm;
	}

	formatTimezoneDate() {
		var now = new Date();
		var tzo = -now.getTimezoneOffset();
		var dif = tzo >= 0 ? '+' : '-';

		return (
			now.getFullYear() +
			'-' +
			this.padNumber(now.getMonth() + 1) +
			'-' +
			this.padNumber(now.getDate()) +
			'T' +
			this.padNumber(now.getHours()) +
			':' +
			this.padNumber(now.getMinutes()) +
			':' +
			this.padNumber(now.getSeconds()) +
			dif +
			this.padNumber(tzo / 60) +
			':' +
			this.padNumber(tzo % 60)
		);
	}
}
